var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"google-sign-in-button",attrs:{"color":"white","light":"","large":"","loading":_vm.isSigningIn,"disabled":_vm.isSigningIn || !_vm.authReady},on:{"click":_vm.signIn}},[_c('v-icon',{attrs:{"left":"","color":"#4285f4"}},[_vm._v("mdi-google")]),_vm._v(" Continue with Google ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }